import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppsComponent } from './main/pages/apps/apps.component';
import { HomePageComponent } from './main/pages/home-page/home-page.component';
import { ContactComponent } from './main/pages/contact/contact.component';
import { AirServiceComponent } from './main/pages/services/air-service/air-service.component';
import { OceanServiceComponent } from './main/pages/services/ocean-service/ocean-service.component';
import { VerticalsComponent } from './main/pages/services/verticals/verticals.component';
import { ValueAddedServiceComponent } from './main/pages/services/value-added-service/value-added-service.component';
import { ContainerSpecificationComponent } from './main/pages/apps/container-specification/container-specification.component';
import { EmissionCalculatorComponent } from './main/pages/apps/emission-calculator/emission-calculator.component';
import { FreightVolumeCalculatorComponent } from './main/pages/apps/freight-volume-calculator/freight-volume-calculator.component';
import { ContainerVesselTrackerComponent } from './main/pages/apps/container-vessel-tracker/container-vessel-tracker.component';
import { IncoTermsComponent } from './main/pages/apps/inco-terms/inco-terms.component';
import { ShippingGlossaryComponent } from './main/pages/apps/shipping-glossary/shipping-glossary.component';
import { AboutComponent } from './main/pages/about/about.component';
// import { PrivacyPolicyComponent } from './main/text-documents/privacy-policy/privacy-policy.component';
// import { AirwayBillConditionsComponent } from './main/text-documents/airway-bill-conditions/airway-bill-conditions.component';
import { DenmarkComponent } from './main/pages/contact/denmark/denmark.component';
import { NorwayComponent } from './main/pages/contact/norway/norway.component';
import { SwedenComponent } from './main/pages/contact/sweden/sweden.component';
import { FinlandComponent } from './main/pages/contact/finland/finland.component';
import { EstoniaComponent } from './main/pages/contact/estonia/estonia.component';
import { BlTermsConditionsComponent } from './main/pages/documents/bl-terms-conditions/bl-terms-conditions.component';
import { TermsOfUseComponent } from './main/pages/documents/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './main/pages/documents/privacy-policy/privacy-policy.component';
import { AirwayBillConditionsComponent } from './main/pages/documents/airway-bill-conditions/airway-bill-conditions.component';
import { SitemapComponent } from './main/pages/documents/sitemap/sitemap.component';
import { UnconventionalCharterSolutionComponent } from './main/pages/home-page/component/latest-news/unconventional-charter-solution/unconventional-charter-solution.component';
import { NotFoundComponent } from './main/not-found/not-found.component';

const routes: Routes = [
  // { path: '', component: AppComponent},
  { path: '', component: HomePageComponent},
  { path: 'apps', component: AppsComponent},
  { path: 'contact', component: ContactComponent},
  { path: 'air-service', component: AirServiceComponent},
  { path: 'air-service/:express', component: AirServiceComponent},
  { path: 'ocean-service', component: OceanServiceComponent},
  { path: 'verticals', component: VerticalsComponent},
  { path: 'value-added-service', component: ValueAddedServiceComponent},
  { path: 'container-specification', component: ContainerSpecificationComponent},
  { path: 'emission-calculator', component: EmissionCalculatorComponent},
  { path: 'freight-volume-calculator', component: FreightVolumeCalculatorComponent},
  { path: 'container-vessel-tracker', component: ContainerVesselTrackerComponent},
  { path: 'inco-terms', component: IncoTermsComponent},
  { path: 'shipping-glossary', component: ShippingGlossaryComponent},
  { path: 'about', component: AboutComponent},
  { path: 'privacy-policy', component: PrivacyPolicyComponent},
  { path: 'airway-bill-conditions', component: AirwayBillConditionsComponent},
  { path: 'denmark', component: DenmarkComponent},
  { path: 'norway', component: NorwayComponent},
  { path: 'sweden', component: SwedenComponent},
  { path: 'finland', component: FinlandComponent},
  { path: 'estonia', component: EstoniaComponent},
  { path: 'bl-terms-conditions', component: BlTermsConditionsComponent},
  { path: 'terms-of-use', component: TermsOfUseComponent},
  { path: 'sitemap', component: SitemapComponent},
  { path: 'an-unconventional-charter-solution', component: UnconventionalCharterSolutionComponent},
  { path: '404', component: NotFoundComponent},
  { path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
